import {
  AutocompleteInputComponent,
  AutocompleteItem,
} from '@delmonicos/shared-design-system-react/src/components//autocomplete-input/autocomplete-input.component';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useChargePointContext } from '@app/feature/charge-point/charge-point.context';

interface ByPhysicalSocketFilterComponentProps {
  physicalSocketId?: string;
  handleChangePhysicalSocketId: (physicalSocketId?: string) => void;
}

export const ByPhysicalSocketFilterComponent = ({
  physicalSocketId,
  handleChangePhysicalSocketId,
}: ByPhysicalSocketFilterComponentProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>('');

  const { channels } = useChargePointContext();

  const physicalSocketsId: AutocompleteItem[] = useMemo(
    () =>
      channels.flatMap((c) =>
        c.physicalSockets.map((p) => ({ label: p.id, key: p.id })),
      ),
    [channels],
  );

  return (
    <Stack gap={GapEnum.M} direction="column">
      <IconText
        iconName="wire"
        text={t(
          '$.charge-point-details.maintenance.filter.physical-socket.title',
        )}
      />

      <AutocompleteInputComponent
        label={t(
          '$.charge-point-details.maintenance.filter.physical-socket.id',
        )}
        placeholder={t(
          '$.charge-point-details.maintenance.filter.physical-socket.id',
        )}
        emptyResultText={t(
          '$.charge-point-details.maintenance.filter.physical-socket.no-physical-socket',
        )}
        value={search}
        selectedItem={
          physicalSocketId
            ? { label: physicalSocketId, key: physicalSocketId }
            : null
        }
        items={physicalSocketsId}
        onChange={setSearch}
        onSearch={setSearch}
        onSelect={(item) => handleChangePhysicalSocketId(item?.key)}
      />
    </Stack>
  );
};
